export const getTmImportanceContent = () => ({
  title: 'tm-importance-title',
  benefits: [
    {
      title: 'marketing-pages-common.tm-importance-item-title-0',
      description: 'marketing-pages-common.tm-importance-item-desc-0',
      imageSrc: '/images/flower.svg',
      imageAlt: 'Flower',
    },
    {
      title: 'marketing-pages-common.tm-importance-item-title-1',
      description: 'marketing-pages-common.tm-importance-item-desc-1',
      imageSrc: '/images/umbrella.svg',
      imageAlt: 'Umbrella',
    },
  ],
  otherBenefits: [
    {
      title: 'marketing-pages-common.tm-importance-benefit-0-title',
      quote: 'marketing-pages-common.tm-importance-benefit-0-quote',
      author: 'marketing-pages-common.tm-importance-benefit-0-author',
      role: 'marketing-pages-common.tm-importance-benefit-0-role',
    },
    {
      title: 'marketing-pages-common.tm-importance-benefit-1-title',
      quote: 'marketing-pages-common.tm-importance-benefit-1-quote',
      author: 'marketing-pages-common.tm-importance-benefit-1-author',
      role: 'marketing-pages-common.tm-importance-benefit-1-role',
    },
    {
      title: 'marketing-pages-common.tm-importance-benefit-2-title',
      quote: 'marketing-pages-common.tm-importance-benefit-2-quote',
      author: 'marketing-pages-common.tm-importance-benefit-2-author',
      role: 'marketing-pages-common.tm-importance-benefit-2-role',
    },
    {
      title: 'marketing-pages-common.tm-importance-benefit-3-title',
      quote: 'marketing-pages-common.tm-importance-benefit-3-quote',
      author: 'marketing-pages-common.tm-importance-benefit-3-author',
      role: 'marketing-pages-common.tm-importance-benefit-3-role',
    },
    {
      title: 'marketing-pages-common.tm-importance-benefit-4-title',
      quote: 'marketing-pages-common.tm-importance-benefit-4-quote',
      author: 'marketing-pages-common.tm-importance-benefit-4-author',
      role: 'marketing-pages-common.tm-importance-benefit-4-role',
    },
  ],
})
